module.exports = "/assets/f6409c90648bf1abf10e4bec5dd8e07f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3V.png
// module id = 1022
// module chunks = 0